import { faLock } from '@fortawesome/free-solid-svg-icons';
import { AwesomeIcon, Body, Box } from '@hover/blueprint';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router';
import { animated } from 'react-spring';

import { EmailSingleSignOnInput, Link } from 'src/shared/components';
import { PasswordField } from 'src/shared/components/forms';
import { useSingleSignOn, useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { Route } from 'src/shared/route';
import { useAccordian } from 'src/shared/transitions';

const PASSWORD_HEIGHT = 100;
const SSO_HEIGHT = 32;

const AnimatedBox = animated(Box);

const Fields = () => {
  const history = useHistory();
  const t = useTranslate(TranslationNamespace.LOGIN);

  const { isEnabled: isSingleSignOnEnabled, isActive: isSingleSignOnActive } =
    useSingleSignOn();

  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { clearErrors } = useFormContext();

  const [heightStyle, transitions] = useAccordian(isSingleSignOnActive, {
    collapsedHeight: SSO_HEIGHT,
    expandedHeight: PASSWORD_HEIGHT,
  });

  useEffect(() => {
    if (isSingleSignOnEnabled)
      history.push(Route.LOGIN_SSO.path + new URL(window.location.href).search);
  }, [history, isSingleSignOnEnabled]);

  useEffect(() => clearErrors('email'), [isSingleSignOnActive, clearErrors]);

  return (
    <>
      <EmailSingleSignOnInput />
      <AnimatedBox
        alignContent="center"
        flexDirection="column"
        position="relative"
        style={heightStyle}
      >
        {transitions.map(({ item, key, props: style }) =>
          item ? (
            <AnimatedBox
              alignItems="center"
              justifyContent="center"
              key={key}
              style={style}
            >
              <AwesomeIcon color="neutral600" icon={faLock} />
              <Body
                color="neutral700"
                margin={0}
                size={400}
                testId="sso-enabled"
              >
                {t('singleSignOn.singleSignOnEnabled')}
              </Body>
            </AnimatedBox>
          ) : (
            <AnimatedBox
              flexDirection="column"
              key={key}
              position="relative"
              style={style}
            >
              <PasswordField
                label={t('password')}
                name="password"
                placeholder={t('password')}
              />
              <Link
                position="absolute"
                right={0}
                size={400}
                testId="forgot-password-link"
                to={Route.LOGIN_FORGOT.path}
                top={0}
              >
                {t('forgotPassword.forgotPassword')}
              </Link>
            </AnimatedBox>
          ),
        )}
      </AnimatedBox>
    </>
  );
};

export { Fields };
